import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

import RichText from '../rich-text';
import Slice from '../slice';

import { PrismicImage } from '../../../../../types';

type HeroProps = {
  textColor: string;
  image: PrismicImage;
};

export const Hero = styled(Slice)<HeroProps>(
  props => css`
    display: flex;
    align-items: flex-end;

    color: ${props.textColor};
    background-image: ${props.image && props.image.Desktop
      ? `url(${props.image.Desktop.url})`
      : 'none'};
    background-size: cover;
    background-position: center center;
    border-left: 0;

    ${media.smallOnly`
      background-position: center right;
      background-image: ${
        props.image && props.image.Mobile
          ? `url(${props.image.Mobile.url})`
          : 'none'
      };
    `};
  `
);

export const TextContent = styled.div`
  margin-top: ${layout.spacing.values.xLarge * 3}px;
  max-width: 66%;

  ${media.smallOnly`
    max-width: 100%;
  `};
`;

export const Title = styled(RichText)``;

export const SubTitle = styled(RichText)``;
